import { render, staticRenderFns } from "./IssueTemplate.vue?vue&type=template&id=4a287e72"
import script from "./IssueTemplate.vue?vue&type=script&lang=js"
export * from "./IssueTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports